<template>
  <span
    class="cursor-pointer hover:text-gray-800 mx-1"
    @click="bcFolderStore.toggleView()"
    v-if="!isTrash"
  >
    <aw-icon
      :icon="bcFolderStore.view === 'table' ? 'grid' : 'list'"
      class="w-4 h-4 "
    />
  </span>
  <span
    class="cursor-pointer hover:text-gray-800 mx-1"
    @click="bcFolderStore.toggleOrder()"
  >
    <aw-icon
      :icon="bcFolderStore.order === 'rank' ? 'sort-az' : 'sort-19'"
      class="w-4 h-4 "
    />
  </span>
  <!-- <span class="cursor-pointer hover:text-gray-800 mx-1">
    <aw-icon icon="arrow-down" class="w-4 h-4"></aw-icon>
  </span> -->
  <!--
  <span class="mx-2" v-if="!$presenter.isPublic">|</span>
  <span
    v-if="!$presenter.isPublic"
    @click="showInfo"
    class="inline-flex cursor-pointer hover:text-gray-800"
  >
    <aw-icon icon="info" class="w-4 h-4 "></aw-icon>
  </span>
  -->
</template>

<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'

export default {
  computed: {
    isTrash() {
      return this.$route.fullPath.includes('trash')
    },
    ...mapStores(useBcFolderStore)
  },
  methods: {
    showInfo() {
      this.$store.commit('nette/updateControl', {
        controlName: 'info',
        data: true,
        key: 'showModal'
      })
    }
  },
}
</script>

<style lang="scss" scoped></style>
